import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';
import MediaLibraryStore from 'stores/MediaLibrary';
import MediaLibraryActions from 'actions/MediaLibrary';
import Loader from 'components/Material/Loader';
import Message from 'services/Message';
import FileList from 'components/Material/FileList';
import * as Icons from 'components/Material/SvgIcons';
import { FloatingActionButton } from 'material-ui';

export default class MediaLibrary extends mixin(RefluxMixin, Component) {
  state = {
    activeDir: {}
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStore(MediaLibraryStore);
  }

  onError(errorMessage) {
    Message.info(errorMessage);
  }

  componentDidMount() {
    const { params } = this.props;
    MediaLibraryActions.listDirectory(params.directoryId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.directoryId !== this.props.params.directoryId) {
      MediaLibraryActions.listDirectory(nextProps.params.directoryId);
    }
  }

  changeDirectory(directoryId) {
    this.props.router.push(`/media-library/${directoryId}`);
  }

  add() {
    const { directoryId } = this.props.params;
    this.props.router.push(`/media-library/${directoryId || 0}/upload`);
  }

  resetFilter() {
    MediaLibraryActions.resetFilter();
  }

  deleteFiles() {
    this.refs.confirmDialog.show();
  }

  toggleMode() {
    MediaLibraryActions.toggleMode();
  }

  onConfirmDelete() {
    MediaLibraryActions.delete(
      Object.keys(this.refs.fileList.getSelectedFiles())
    );
    this.refs.confirmDialog.dismiss();
  }

  gotoFile(file) {
    const { directoryId } = this.props.params;
    this.props.router.push(`/media-library/${directoryId || 0}/${file.id}`);
  }

  createDirectory(name) {
    const { breadcrumbs } = this.state;
    MediaLibraryActions.createDirectory(
      (breadcrumbs && breadcrumbs.length > 0 && breadcrumbs[0].id) || 0,
      name
    );
  }

  render() {
    if (this.state.loading) {
      return (
        <AppPage
          header={
            <RulerBar
              title={this.context.getIntlMessage('menu.mediaLibrary')}
            />
          }
          className={'settings'}
        >
          <Loader />
        </AppPage>
      );
    }
    return (
      <AppPage
        key="settings"
        header={
          <RulerBar title={this.context.getIntlMessage('menu.mediaLibrary')} />
        }
        className={'media-library'}
        style={{ zIndex: 1 }}
      >
        <FileList
          onCreateDirectory={::this.createDirectory}
          onToggleMode={::this.toggleMode}
          grid={this.state.grid}
          breadcrumbs={this.state.breadcrumbs}
          onChangeDirectory={::this.changeDirectory}
          items={this.state.list}
          labelProperty="name"
          onTouchTapItem={this.gotoFile.bind(this)}
          hasDivider={false}
          floatingActionButton={
            <FloatingActionButton onTouchTap={this.add.bind(this)}>
              <Icons.ContentAdd />
            </FloatingActionButton>
          }
        >
          {this.props.children}
        </FileList>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/MediaLibrary.js